export default __webpack_public_path__ + "static/media/google.fc295ce9.svg";